let registry;
/**
 * When the dispatcher doesn't find any instances then we
 * queue until a match is found
 * (until an instance that matches the ID is created and registered)
 */
let dispatchQueue;
if (typeof globalThis.__OS__ === 'undefined') {
    globalThis.__OS__ = {
        registry: new Map(),
        dispatchQueue: new Map(),
        version: process.env.__VERSION__,
    };
}
/**
 * Always use the global registry to ensure only one registry is in use
 */
registry = globalThis.__OS__.registry;
dispatchQueue = globalThis.__OS__.dispatchQueue;
export { registry, dispatchQueue };
